import React, { useState } from "react";
import FontAwesome from "react-fontawesome";
// import "./../../App.css";
const Renderface = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
  handelDelete,
  search,
  onUpdate,
}) => {
  const [empData, setempData] = useState({
    empid: "",
    empname: "",
  });
  const [isOpen, setisOpen] = useState(false);

  const [showScroll, setShowScroll] = useState(false);
  const [url, seturl] = useState("http://wms.advanceagro.net/wsface/api/face/CardImage?IdentityID=");
  
  const handleCancle = () => {
    setisOpen(false);
  };
  const handleDeviceClick = (id, name) => {
    setempData({ empid: id, empname: name });
    setisOpen(true);
  };
  const onConfirm = () => {
    setisOpen(false);
    onUpdate();
  };

  if (!list) <></>;

  return (
    <div className="row course-list list m-1">
      {/* <Modaldevice
        isOpen={isOpen}
        onCancel={handleCancle}
        value={empData}
        header={empData.empname}
        onConfirm={onConfirm}
        //ref={lastBookElementRef}
      /> */}
      {list &&
        list.map((item, index) => {
          if (list.length === index) {
            return (
              <div
               // ref={lastBookElementRef}
                key={index + 1}
                className="card text-dark p-0 mb-2 me-2  col-xs-12 col-sm-3"
              >
                <div className="container-fluid">
                  <span className="badge rounded-pill bg-secondary">
                    {item.autoregisterID}
                  </span>

                  <div className="row no-gutters align-items-center justify-content-left">
                    <div className="col-auto text-center mb-2 p-1 text-center">
                      <img
                        src={url+item.IdentityID + "&size=320"}
                        className="rounded-circle me-1"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title=""
                        alt=""
                        style={{
                          maxHeight: "100px",
                          Width: "100%",
                          maxWidth: "100px",
                        }}
                      ></img>
                    </div>

                    <div className="col-auto ms-2">
                      <div className="card-body p-1">
                        <div className="card-text">
                          <h6
                            className="card-title d-inline me-2"
                            style={{ fontSize: "14px" }}
                          >
                            {item.FnameT} {item.LnameT}
                          </h6>
                        </div>
                        <div className="card-text">
                          <h6
                            className="card-text d-inline me-2"
                            style={{ fontSize: "14px" }}
                          >
                            <span
                              aria-hidden="true"
                              className="fa fa-briefcase"
                            />{" "}
                            {/* {item.nationlname} */}
                          </h6>
                          <h6
                            className="card-text d-inline"
                            style={{ fontSize: "14px" }}
                          >
                            <span
                              aria-hidden="true"
                              className="fa fa-building"
                            />{" "}
                            {/* {item.comname} */}
                          </h6>
                        </div>
                        <h6>
                          <div
                            className="card-text"
                            style={{ fontSize: "14px" }}
                          >
                            <span className="card-text">
                              <span aria-hidden="true" /> {"ID:"}
                              {item.IdentityID}
                       
                            </span>
                          </div>
                        </h6>
                        {item.ActionStatus =="1" &&
                        <div className="row">            
                  <div className="col-sm-6 col-xs-12">
                  <button className="btn btn-primary" style={{ fontSize: "12px" }}
                              onClick={() =>
                                handleOnClick({IdentityID :item.IdentityID,FnameT : item.FnameT + " " + item.LnameT}) }> 
                              <span>ยืนยัน</span>
                              </button> 
                    </div>
                    </div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div
              key={index + 1}
              className="card text-dark p-0 mb-2 me-2  col-xs-12 col-sm-3"
            >
              <div className="container-fluid">
                <span className="badge rounded-pill bg-secondary">
                  {index + 1}
                </span>

                <div className="row no-gutters align-items-center justify-content-left">
                  <div className="col-auto text-center mb-2 p-1 text-center">
                    <img
                      src={url+item.IdentityID + "&size=320"}
                      className="rounded-circle me-1"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title=""
                      alt=""
                      style={{
                        maxHeight: "100px",
                        Width: "100%",
                        maxWidth: "100px",
                      }}
                    ></img>
                  </div>

                  <div className="col-auto ms-2">
                    <div className="card-body p-1">
                      <div className="card-text">
                        <h6
                          className="card-title d-inline me-2"
                          style={{ fontSize: "14px" }}
                        >
                          {item.FnameT} {item.LnameT}
                        </h6>
                      </div>
                      <div className="card-text">
                        <h6
                          className="card-text d-inline me-2"
                          style={{ fontSize: "14px" }}
                        >
                          <span
                            aria-hidden="true"
                            className="fa fa-briefcase"
                          />{" "}
                          {/* {item.nationlname} */}
                        </h6>
                        <h6
                          className="card-text d-inline"
                          style={{ fontSize: "14px" }}
                        >
                          <span
                            aria-hidden="true"
                            className="fa fa-building"
                          />{" "}
                          {/* {item.comname} */}
                        </h6>
                      </div>
                      <h6>
                        <div
                          className="card-text"
                          style={{ fontSize: "14px" }}
                        >
                          <span className="card-text">
                            <span aria-hidden="true" /> {"ID:"}
                            {item.IdentityID}
                     
                          </span>
                        </div>
                      </h6>
                      {item.ActionStatus =="1" && 
                      <div className="row">            
                  <div className="col-sm-6 col-xs-12">
                  <button className="btn btn-primary" style={{ fontSize: "12px" }}
                              onClick={() =>
                                handleOnClick({IdentityID :item.IdentityID,FnameT : item.FnameT +" "+ item.LnameT})} > 
                              <span>ยืนยัน</span>
                              </button> 
                    </div>
       
                    </div>  }                                              
                    </div>
                  </div>
                </div>
              </div>
              </div>
            );
          }
        })}
    </div>
  );
};

export default Renderface;
